import React, { Component } from 'react';
import { dispatch } from '../../../../../.muji/store';
import { connect } from '@souche-f2e/muji';
import { Button, Modal } from 'antd';
import { Root } from '../_style/Top';
import AuctionModal from './AuctionModal';
const mapStateToProps = (rootState) => ({
    _state: rootState.auctionOperate,
});
class Top extends Component {
    constructor(props) {
        super(props);
        this.stopAuction = () => {
            // 暂停拍卖 所有按钮不可点击
            dispatch.auctionOperate.stopAuction({});
        };
        this.goOnAuction = () => {
            // 继续拍卖
            dispatch.auctionOperate.goOnAuction({});
        };
        this.beginFormalAuction = () => {
            this.setState({
                showCloseModal: true,
                modalType: 'endSimulate',
            });
        };
        this.closeFormalAuction = () => {
            this.setState({
                showCloseModal: true,
                modalType: 'close',
            });
        };
        this.closeClose = () => {
            this.setState({
                showCloseModal: false,
            });
        };
        this.switchCar = () => {
            // 切车
            Modal.confirm({
                title: '点击「确认」后当前车辆将流拍，是否确认切至下一辆车？',
                onOk() {
                    dispatch.auctionOperate.switchCar({});
                },
            });
        };
        this.state = {
            showCloseModal: false,
            modalType: 'endSimulate',
        };
    }
    render() {
        const { showCloseModal, modalType } = this.state;
        const { nowNum, totalCarNum, sessionId, stopBtn, nowCarAuctionId, disabledStopBtn, isFormal, auctionDuration, isTheLast, } = this.props._state;
        const { style, className } = this.props;
        return (<React.Fragment>
        <Root className={['flex__row-startE', className]} style={style}>
          <div className="top--left1">
              {!isFormal && '本场未开拍'}
              {isFormal && `本场已开拍 ${auctionDuration}`}
          </div>
          <div>
              {!isFormal && '模拟拍卖中'}
              {isFormal && `拍卖进度 ${nowNum}/${totalCarNum}`}
          </div>
          <div className="top--btn">
              {!stopBtn &&
            <Button className={`btn_stop ${disabledStopBtn ? 'disabled' : ''}`} disabled={disabledStopBtn} onClick={this.stopAuction}>暂停拍卖</Button>}
              {stopBtn &&
            <Button className="btn_goOn" onClick={this.goOnAuction}>继续</Button>}

              {!isFormal &&
            <Button className="btn_begin" onClick={this.beginFormalAuction}>开始正式拍卖</Button>}
              {isFormal &&
            <Button className="btn_end" onClick={this.closeFormalAuction}>结束拍卖</Button>}
              {!isTheLast &&
            <Button className="btn_switchCar" onClick={this.switchCar}>切至下一辆车</Button>}
          </div>
        </Root>
        <AuctionModal type={modalType} id={sessionId} auctionId={nowCarAuctionId} showCloseModal={showCloseModal} cancelClose={this.closeClose} okClose={this.closeClose}/>
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(Top);
